<template>
  <div>
    <p class="font-semibold text-primary text-lg lg:text-2xl mb-2 lg:mb-4">Data Privacy</p>

    <div class="flex flex-col lg:flex-row space-x-0 lg:space-x-2 items-center">
      <p class="leading-normal text-sm lg:text-base">
        By participating in this Fun Run event, you consent to PAFCPIC's data privacy policy in compliance with the Data
        Privacy Act of 2012.
        <br /><br />
        PAFCPIC will be covering the event by capturing photos and videos which may be posted in all of PAFCPIC's
        communication channels including its Social Media accounts, Website, Newsletter, Annual Reports, and other
        in-house or external publishing partners.
        <br /><br />
        To read more about PAFCPIC's Data Privacy Policy, you may visit this link:
        <a href="https://pafcpic.ph/privacy-policy" target="_blank" rel="noopener noreferrer"
          class="text-primary hover:underline">
          https://pafcpic.ph/privacy-policy
        </a>
      </p>

      <img src="https://resource.pafcpic.net/assets/funrun/npc_seal.png" alt="NPC Seal" class="my-3 lg:my-0 w-16 lg:w-32 h-auto pl-0 lg:pl-4 " />
    </div>

    <!-- Checkbox -->
    <div class="flex flex-row space-x-2 text-sm lg:text-base mt-4 items-center">
      <input type="checkbox" id="agree" v-model="isAgreed" class="cursor-pointer w-4 h-4" style="accent-color: #016B00;"/>
      <label for="agree" class="cursor-pointer select-none">I agree with the Privacy Policy</label>
    </div>

    <!-- Button -->
    <div class="w-full flex justify-end mt-4">
      <div class="w-full lg:w-1/4">
        <ButtonControl ref="proceed" variant="primary" :disabled="!isAgreed" @click="$emit('close')">
          PROCEED
        </ButtonControl>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonControl from '../controls/ButtonControl.vue';

export default {
  name: "DataPrivacy",
  inject: ['setLoading'],
  components: { ButtonControl },
  data() {
    return {
      isAgreed: false
    };
  },
  methods: {
    // navigate() {
    //   this.$router.push('/registration');
    //   this.$store.state.form = null;

    // }
  }
};
</script>
